import type { FC } from "react";
import Box from "@mui/material/Box";
import { CircularProgress } from "@privacy/ui";
import { useGetUsersFromCurrentOrganisation } from "../../../api/users";
import type { InputProps } from "../../DynamicInput";
import { PersonIcon3 } from "../../../shared/icons";
import { SingleAutocomplete } from "../../shared/SingleAutocomplete";
import type { MultiProps, SingleProps } from "../../inlineForm/inputs/Person";
import { MultiAutocomplete } from "../../shared/MultiAutocomplete";

export const PersonMultiSingleAutocomplete: FC<InputProps<string>> = props => {
  return <Person {...props} variant="singleSelect" />;
};
export const PersonMultiMultipleAutocomplete: FC<InputProps<string[]>> = props => {
  return <Person {...props} variant="multiSelect" />;
};

const Person: FC<SingleProps | MultiProps> = props => {
  const { data } = useGetUsersFromCurrentOrganisation();

  if (!data)
    return (
      <Box sx={{ py: 2, pl: 2, width: "100%" }}>
        <CircularProgress size={18} />
      </Box>
    );

  const options = data.users.map(user => ({
    label: `${user.firstName} ${user.lastName}`,
    value: user.userId,
    description: user.email,
  }));

  return props.variant === "singleSelect" ? (
    <SingleAutocomplete
      {...props}
      options={options}
      renderIcon={iconProps => <PersonIcon3 {...iconProps} />}
      noOptionsTextKey="DynamicForm.PersonSelect.Empty"
      placeholderKey="DynamicForm.Inline.InputPlaceholder"
      chipVariant="entity"
    />
  ) : (
    <MultiAutocomplete
      {...props}
      options={options}
      renderIcon={iconProps => <PersonIcon3 {...iconProps} />}
      noOptionsTextKey="DynamicForm.PersonSelect.Empty"
      placeholderKey="DynamicForm.Inline.InputPlaceholder"
      chipVariant="entity"
    />
  );
};
